var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 30,
    viewBox: "0 0 96 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.461 17.0605C40.7176 16.8557 39.1794 16.7532 38.0551 16.7532C36.7979 16.7532 35.2863 16.8557 35.2863 18.339C35.2863 19.0826 35.7458 19.3102 37.1322 19.9248L38.2336 20.4104C40.7442 21.5371 41.7963 22.4324 41.7963 24.5038C41.7963 27.9068 39.1072 29.2915 35.1077 29.2915C33.1099 29.2915 30.907 28.9349 30.3145 28.73L30.6981 26.4272C31.9781 26.579 33.3378 26.708 35.385 26.708C37.0524 26.708 38.3818 26.4272 38.3818 24.9401C38.3818 24.0941 37.945 23.8133 36.2016 23.047L35.2027 22.6107C32.9998 21.6395 31.8983 20.5394 31.8983 18.5401C31.8983 14.9057 34.9216 14.1621 37.9982 14.1621C40.1251 14.1621 41.8419 14.4428 42.8408 14.7236L42.461 17.0605Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3728 22.7966H46.7368C46.6077 23.5402 46.5317 23.9992 46.5317 24.3824C46.5317 25.7405 47.223 26.5334 49.8627 26.5334C51.401 26.5334 53.1937 26.3817 55.1422 26.1996L54.732 28.7072C53.6039 28.9614 51.6555 29.3218 49.2246 29.3218C45.1492 29.3218 43.2539 27.6829 43.2539 24.2534C43.2539 23.5098 43.3299 22.6676 43.5084 21.7723L43.6869 20.877C44.6592 16.0665 47.299 14.1697 51.1959 14.1697C54.9637 14.1697 56.8058 16.0627 56.8058 19.314C56.8058 20.3648 56.6539 21.3853 56.3728 22.7966ZM50.9376 16.8822C48.2713 16.8822 47.4775 18.7259 47.1698 20.3648L47.1432 20.5962H53.395C53.4976 20.0348 53.5508 19.5454 53.5508 19.1622C53.5546 17.9331 53.0418 16.8822 50.9376 16.8822Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0014 20.2093L69.4897 28.9349H66.1093L67.697 19.8527C67.7729 19.3405 67.8261 18.9042 67.8527 18.5211C67.8527 17.4702 67.3931 17.0112 66.1359 17.0112C65.061 17.0112 63.7545 17.3185 62.2162 18.062L60.2943 28.9386H56.9102L59.4207 14.5566H62.6492L62.4973 15.6303C64.1875 14.6325 65.8549 14.1697 67.3134 14.1697C70.3633 14.1697 71.2597 15.7555 71.2597 17.8799C71.2559 18.597 71.1305 19.4164 71.0014 20.2093Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7834 17.216H78.2739L76.8382 25.0235C76.7356 25.5091 76.7091 25.8164 76.7091 26.0478C76.7091 26.6093 77.0167 26.7383 77.8865 26.7383C78.6043 26.7383 79.6564 26.689 80.0628 26.6359L79.7058 28.9121C79.2956 29.0145 78.0156 29.3218 76.7091 29.3218C74.377 29.3218 73.3781 28.2975 73.3781 26.2755C73.3781 25.8657 73.4046 25.3801 73.5072 24.868L74.8897 17.216L72.25 17.0112L72.6336 14.5528H75.3227L75.9874 10.8691H79.3678L78.7031 14.5528H82.2126L81.7834 17.216Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5681 22.7966H84.9321C84.803 23.5402 84.727 23.9992 84.727 24.3824C84.727 25.7405 85.4183 26.5334 88.058 26.5334C89.5963 26.5334 91.389 26.3817 93.3375 26.1996L92.9273 28.7072C91.7992 28.9614 89.8508 29.3218 87.4199 29.3218C83.3445 29.3218 81.4492 27.6829 81.4492 24.2534C81.4492 23.5098 81.5252 22.6676 81.7037 21.7723L81.8822 20.877C82.8545 16.0665 85.4943 14.1697 89.3912 14.1697C93.159 14.1697 95.0011 16.0627 95.0011 19.314C95.0049 20.3648 94.853 21.3853 94.5681 22.7966ZM89.1367 16.8822C86.4704 16.8822 85.6766 18.7259 85.3689 20.3648L85.3423 20.5962H91.5941C91.6967 20.0348 91.7499 19.5454 91.7499 19.1622C91.7499 17.9331 91.2371 16.8822 89.1367 16.8822Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3769 0C36.9336 0 34.6395 1.16847 33.257 2.61008L28.9043 7.19669H50.0297C51.473 7.19669 53.7671 6.02822 55.1497 4.58661L59.5024 0H38.3769Z",
    fill: "url(#paint0_linear_1674_23084)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5449 3.99487C22.1016 3.99487 19.8075 5.16334 18.425 6.60496L14.0723 11.1954H35.1977C36.641 11.1954 38.9351 10.0269 40.3176 8.58528L44.6703 3.99867H23.5449V3.99487Z",
    fill: "url(#paint1_linear_1674_23084)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47265 7.59497C8.02934 7.59497 5.73524 8.76344 4.35271 10.2051L0 14.7917H21.1254C22.5687 14.7917 24.8628 13.6232 26.2454 12.1816L30.5981 7.59497H9.47265Z",
    fill: "url(#paint2_linear_1674_23084)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1674_23084",
    x1: 29.3178,
    y1: 8.84707,
    x2: 48.5022,
    y2: 2.06818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4181,
    stopColor: "#F0EFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD1D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1674_23084",
    x1: 14.7411,
    y1: 7.59447,
    x2: 44.1113,
    y2: 7.59447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1843,
    stopColor: "#F9CE34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3788,
    stopColor: "#F7B32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#F5A025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7823,
    stopColor: "#F49521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49120"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1674_23084",
    x1: -12.8748,
    y1: 11.8797,
    x2: 21.8336,
    y2: 11.0321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2518,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2741,
    stopColor: "#DF1366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4121,
    stopColor: "#BD1459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#A2144E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6963,
    stopColor: "#8F1546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8434,
    stopColor: "#841542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#801540"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSente);
export default __webpack_public_path__ + "static/media/logo-sente.2dcaeb794b2f9cd4ba2ec4540c98d656.svg";
export { ForwardRef as ReactComponent };